// DUB-99: canonical division ordering for the whole app.
//
// Owners want divisions to render in this order anywhere a tournament's
// brackets are listed:
//
//   Men's Doubles → Men's Singles → Mixed Doubles → Women's Doubles → Women's Singles
//
// = gender (male, mixed, female) → team_size DESC (doubles before singles) → name.
//
// Use compareDivisions for raw division rows OR bracket-shaped objects that
// carry division fields. The function reads either casing convention so a
// single helper covers every backend response shape we feed into it.

const GENDER_RANK = { male: 0, mixed: 1, female: 2, team: 3 }

function divisionFields(item) {
  if (!item) return { gender: null, team_size: 0, name: '' }
  const gender =
    item.gender ?? item.divisionGender ?? item.division_gender ?? null
  const team_size =
    item.team_size ?? item.teamSize ?? item.divisionTeamSize ?? item.division_team_size ?? 0
  const name =
    item.name ?? item.divisionName ?? item.division_name ?? ''
  return { gender, team_size, name }
}

export function compareDivisions(a, b) {
  const fa = divisionFields(a)
  const fb = divisionFields(b)
  const ga = GENDER_RANK[fa.gender] ?? 99
  const gb = GENDER_RANK[fb.gender] ?? 99
  if (ga !== gb) return ga - gb
  // Doubles (team_size 2) before singles (team_size 1).
  if (fa.team_size !== fb.team_size) return fb.team_size - fa.team_size
  return (fa.name || '').localeCompare(fb.name || '')
}
